import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-20">
      <div className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Terms of Service
            </h1>
            <p className="text-gray-400">Last updated: December 26, 2024</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-300">
            <p className="text-lg leading-relaxed">
              By accessing or using this website, you agree to the following terms:
            </p>

            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Use of Website</h2>
              <p>
                You agree to use this website only for lawful purposes and not to misuse or attempt to disrupt its functionality.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Services</h2>
              <p className="mb-3">
                Orboroi provides AI data operations, data annotation, validation, and related services.
              </p>
              <p>
                Any formal engagement is governed by separate agreements, contracts, or statements of work.
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. No Professional Advice</h2>
              <p>
                Content on this website is provided for general informational purposes and does not constitute professional or technical advice.
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
              <p>
                All content, branding, text, graphics, and materials on this website are the property of Orboroi and may not be copied, reproduced, or distributed without permission.
              </p>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Confidentiality</h2>
              <p className="mb-3">
                Any information shared with us through this website will be handled in accordance with our Privacy Policy.
              </p>
              <p>
                Client-specific confidentiality obligations are governed by separate agreements (e.g., NDAs).
              </p>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Orboroi shall not be liable for any indirect, incidental, or consequential damages arising from the use of this website.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Third-Party Links</h2>
              <p>
                This website may contain links to third-party websites. We are not responsible for their content, policies, or practices.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Modifications</h2>
              <p>
                We may update these Terms at any time. Continued use of the website constitutes acceptance of the updated Terms.
              </p>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Governing Framework</h2>
              <p>
                These Terms are governed by applicable laws and general international business practices, unless otherwise specified in formal agreements.
              </p>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">10. Contact</h2>
              <p>
                For any questions regarding these Terms of Service, please contact us at:
              </p>
              <p className="mt-2">
                <a href="mailto:contact@orboroi.com" className="text-[#379F7F] hover:underline">
                  contact@orboroi.com
                </a>
              </p>
            </section>
          </div>

          {/* Back to home link */}
          <div className="mt-12 pt-8 border-t border-gray-800">
            <Link to="/" className="text-[#379F7F] hover:underline inline-flex items-center">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;